import React, { useMemo } from 'react';
import range from 'lodash/range';
import gridStyle from './GridRow.scss';
var VisibleGridRow = function (_a) {
    var start = _a.start, end = _a.end, elementWidth = _a.elementWidth, elementHeight = _a.elementHeight, elementSpacing = _a.elementSpacing, _b = _a.withShadowSpace, withShadowSpace = _b === void 0 ? true : _b, renderElement = _a.renderElement;
    var inlineStyles = useMemo(function () {
        var _a;
        var rowWidth = (elementWidth + elementSpacing) * (end - start) - elementSpacing;
        var styles = (_a = {
                width: rowWidth
            },
            _a['containIntrinsicSize'] = "".concat(rowWidth, "px ").concat(elementHeight, "px"),
            _a['contentVisibility'] = 'auto',
            _a);
        // create space around contents for shadows, ribbons, etc.
        // but draw it back in with negative margin so bounds match width
        if (withShadowSpace) {
            styles.margin = "-".concat(elementSpacing, "px");
            styles.padding = "".concat(elementSpacing, "px");
        }
        else if (start > 0) {
            // gap between rows
            styles.marginTop = "".concat(elementSpacing, "px");
        }
        return styles;
    }, [
        elementHeight,
        elementSpacing,
        elementWidth,
        end,
        start,
        withShadowSpace,
    ]);
    return (React.createElement("div", { className: gridStyle['row'], style: inlineStyles }, range(start, end).map(function (index) {
        return renderElement({
            width: elementWidth,
            height: elementHeight,
            index: index,
            style: {
                width: elementWidth,
                height: elementHeight,
                marginLeft: index > start ? elementSpacing : 0,
            },
            onscreen: true,
            visible: true,
        });
    })));
};
VisibleGridRow.displayName = 'VisibleGridRow';
export default VisibleGridRow;
//# sourceMappingURL=VisibleGridRow.js.map